import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, TextareaAutosize,
    TextField
} from "@material-ui/core";



import React, {useEffect, useState} from "react";
import axios from "axios";
import { api } from "./api/client";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import {FileOpen, Grid3x3} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {toast, ToastContainer} from "react-toastify";

let timer=0;
let file_name;

function ekVar(value) {
    return value === 1 || value === true || value === "1" || value === "true";
}

function satirdaEkVar(row, note) {
    const metin = note != null ? note : row && row.genel_notlar;
    if (String(metin || "").trim()) return true;
    if (!row) return false;
    return Boolean(row.irsaliye || row.siparis_mektubu || row.servis_formu || row.diger);
}

export default function ModalboxEkler(props) {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [yesil, setYesil] = useState(() => ekVar(props.dosyaVar));
    const [teklif_no, setTeklif_no] = useState("");
    const [irsaliye,setIrsaliye]= useState();
    const [siparisMektubu,setSiparisMektubu]= useState();
    const [servisFormu,setServisFormu]= useState();
    const [diger,setDiger]= useState();
    const [dosyalar,setDosyalar]=useState([]) ;
    const [deleteFileState,setDeleteFileState]=useState(false) ;
    const [selectedFile,setSelectedFile]= useState();
    const [selectedFileColumn,setSelectedFileColumn]= useState();
    const [genelNotlar,setGenelNotlar]= useState();

    useEffect(() => {
        setYesil(ekVar(props.dosyaVar));
    }, [props.dosyaVar, props.teklifNo]);


    const onIrsaliyeChanged = event => {
        // Update the state
        setIrsaliye(event.target.files[0]);
        console.log(event.target.files[0]);

    };
/*
    useEffect(async () => {
        setTeklif_no(props.teklifNo);
        const res = await api.get(`/teklifler/${encodeURIComponent(props.teklifNo)}/dosyalar`, {
            params: {
                teklif_no: props.teklifNo
            }
        });
        const data = res.data

        const files = data.map(d => ({
            "id": d.id,
            "irsaliye": d.irsaliye ? d.irsaliye : "",
            "servis_formu": d.servis_formu ? d.servis_formu : "",
            "siparis_mektubu": d.siparis_mektubu ? d.siparis_mektubu:"",
            "diger": d.diger ? d.diger : "",
            "genel_notlar": d.genel_notlar ? d.genel_notlar : ""
        }))
        if(files[0].irsaliye!==""  || files[0].servis_formu!=="" || files[0].diger!=="" || files[0].siparis_mektubu!=="" ) {
            setDosyaVar(true);
        }

        //console.log('dosyabilgisi',files,props.teklifNo)
    },[props.teklifNo])
*/
    const onSiparisMektubuChanged = event => {

        // Update the state
        setSiparisMektubu(event.target.files[0]);
        console.log(event.target.files[0])

    };
    const onServisFormuChanged = event => {
        // Update the state
        setServisFormu(event.target.files[0]);
        console.log(event.target.files[0])

    };
    const onDigerChanged = event => {

        // Update the state
        setDiger(event.target.files[0]);
        console.log(event.target.files[0])

    };
    /*
        useEffect(()=>{
            if
        },[])
    */



    const mapDosyaRow = (d) => ({
        id: d.id,
        irsaliye: d.irsaliye,
        servis_formu: d.servis_formu,
        siparis_mektubu: d.siparis_mektubu,
        diger: d.diger,
        genel_notlar: d.genel_notlar,
        irsaliye_url: d.irsaliye_url || null,
        servis_formu_url: d.servis_formu_url || null,
        siparis_mektubu_url: d.siparis_mektubu_url || null,
        diger_url: d.diger_url || null,
    });

    /** OBS presigned URL varsa onu aç; yoksa eski /dosyalar/ yolu. */
    const openDosya = (slotKey) => {
        const url = dosyalar?.[`${slotKey}_url`];
        const name = dosyalar?.[slotKey];
        if (url) {
            window.open(url, "_blank");
            return;
        }
        if (name) {
            window.open("/dosyalar/" + name, "_blank");
        }
    };

    const handleClickOpen = async () => {
        setOpen(true);
        setTeklif_no(props.teklifNo);
        const res = await api.get('/teklifler/' + props.teklifNo + '/dosyalar');
        const data = res.data

        const files = data.map(mapDosyaRow)
        const row = files[0] || {};
        setDosyalar(row);
        setGenelNotlar(row.genel_notlar || "");
        setYesil(satirdaEkVar(row));

    };

    const deleteFile= async (columnName,fileName) => {

        await api.delete('/teklifler/' + props.teklifNo + '/dosyalar', {
            params: {
                column_name:columnName,
                file_name: fileName

            }
        } ).then(async (r) => {
            console.log(r);
            setDeleteFileState(false);
            toast.success("Dosya başarıyla silindi");

            const res = await api.get('/teklifler/' + props.teklifNo + '/dosyalar');
            const data = res.data

            const files = data.map(mapDosyaRow)
            const row = files[0] || {};
            setDosyalar(row);
            setYesil(satirdaEkVar(row, genelNotlar));

        });

    };
    const deleteFileOpen= async (columnName,fileName) => {
        setDeleteFileState(true);
        setSelectedFile(fileName);
        setSelectedFileColumn(columnName);
    }

    const handleDeleteDialogClose = () => {
        setDeleteFileState(false);
    };
    const handleClose = () => {
        setOpen(false);
    };
    function onMouseLeave() {
        clearTimeout(timer);
        console.log('mouse çıktı')
    }
    const handleChange = name=> e => {
        setGenelNotlar(e.target.value)
    };

    return (

        <div>


            <IconButton variant="outlined" style={{color: yesil ? "green": "red"}} size={"small"} onClick={handleClickOpen } id={props.teklifNo}  >
                <FileOpen />
            </IconButton>

            <Dialog

                maxWidth="lg"
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Dosya ve Not Ekle</DialogTitle>
                <DialogContent>

                    <Grid container  >
                         <TextareaAutosize
                            margin="dense"
                            id="genel_notlar"
                            label="Teklif Notları"
                            value={genelNotlar || ""}
                            onChange={handleChange('genel_notlar')}
                            fullWidth
                            multiline
                            minRows="8"
                            style={{ width: 700 }}
                        />
                    </Grid>
                    <DialogActions>
                        <Button
                            onClick={

                                async () => {
                                    //console.log(props.row);
                                    await api.post('/teklifler/' + props.teklifNo + '/notlar', {
                                        'genel_notlar': genelNotlar,
                                    })
                                        .then((response) => {
                                            console.log(response);
                                            toast.success("Not kaydedildi");
                                            setYesil(satirdaEkVar(dosyalar, genelNotlar));
                                            if (typeof props.onSaved === "function") props.onSaved();
                                        })
                                        .catch((error) => {
                                            // Error 😨
                                            if (error.response) {
                                                toast.error("Not kaydedilemedi!");
                                                /*
                                             * The request was made and the server responded with a
                                             * status code that falls out of the range of 2xx
                                             */
                                                console.log(error.response.data);
                                                console.log(error.response.status);
                                                console.log(error.response.headers);
                                            } else if (error.request) {
                                                /*
                                                 * The request was made but no response was received, `error.request`
                                                 * is an instance of XMLHttpRequest in the browser and an instance
                                                 * of http.ClientRequest in Node.js
                                                 */
                                                console.log(error.request);
                                            } else {
                                                // Something happened in setting up the request and triggered an Error
                                                console.log('Error', error.message);
                                            }
                                            console.log(error.config);
                                        });

                                }

                            }
                            color="primary"
                        >
                            Notu Kaydet
                        </Button>
                    </DialogActions>
                    <p></p>
                    <div>

                        <h4>Dosya seçip yükleme butonuna basınız</h4>
                    </div>
                    <Grid container  >
                        <Grid item xs={3}  >İrsaliye</Grid>
                        <Grid item xs={4}  >
                            <input type="file" onChange={onIrsaliyeChanged}   />
                        </Grid>
                        <Grid item xs={2}  > {dosyalar.irsaliye &&   <IconButton variant="outlined" color="success" size={"small"} onClick={() => openDosya('irsaliye')}  target={'_blank'}  ><FileOpen /></IconButton> } </Grid>
                        <Grid item xs={2}  > {dosyalar.irsaliye &&  <IconButton size="small" style={{width:30}}  onClick={()=>{deleteFileOpen('irsaliye',dosyalar.irsaliye)}}  color="error"  variant="outlined" target={"_blank"} title={'Dosyayı Sil'} > <DeleteForeverIcon /></IconButton> }</Grid>
                    </Grid>
                    <p></p>
                    <Grid container  >
                        <Grid item xs={3}  >Sipariş Mektubu</Grid>
                        <Grid item xs={4}  >
                            <input type="file" onChange={onSiparisMektubuChanged}   />
                        </Grid>
                        <Grid item xs={2}  > {dosyalar.siparis_mektubu &&  <IconButton variant="outlined" color="success" size={"small"}  onClick={() => openDosya('siparis_mektubu')}  ><FileOpen /></IconButton> }</Grid>
                        <Grid item xs={2}  > {dosyalar.siparis_mektubu &&  <IconButton size="small" style={{width:30}}   onClick={()=>{deleteFileOpen('siparis_mektubu',dosyalar.siparis_mektubu)}}  color="error"  variant="outlined" target={"_blank"} title={'Dosyayı Sil'} > <DeleteForeverIcon /></IconButton> }</Grid>

                    </Grid>
                    <p></p>
                    <Grid container  >
                        <Grid item xs={3}  >Servis Formu</Grid>
                        <Grid item xs={4}  >
                            <input type="file" onChange={onServisFormuChanged}   />
                        </Grid>
                        <Grid item xs={2}  > {dosyalar.servis_formu &&  <IconButton variant="outlined" color="success" size={"small"}  onClick={() => openDosya('servis_formu')}  ><FileOpen /></IconButton> } </Grid>
                        <Grid item xs={2}  > {dosyalar.servis_formu &&  <IconButton size="small" style={{width:30}}   onClick={()=>{deleteFileOpen('servis_formu',dosyalar.servis_formu)}}  color="error"  variant="outlined" target={"_blank"} title={'Dosyayı Sil'} > <DeleteForeverIcon /></IconButton>}</Grid>
                    </Grid>
                    <p></p>
                    <Grid container  >
                        <Grid item xs={3}  >Diğer</Grid>
                        <Grid item xs={4}  >
                            <input type="file" onChange={onDigerChanged}  />
                        </Grid>
                        <Grid item xs={2}  > {dosyalar.diger &&  <IconButton variant="outlined" color="success" size={"small"}  onClick={() => openDosya('diger')}  ><FileOpen /></IconButton> } </Grid>
                        <Grid item xs={2}  > {dosyalar.diger &&  <IconButton size="small" style={{width:30}} onClick={()=>{deleteFileOpen('diger',dosyalar.diger)}} color="error" variant="outlined" target={"_blank"} title={'Dosyayı Sil'} > <DeleteForeverIcon /></IconButton> }</Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button

                        onClick={

                            async () => {

                                // Create an object of formData
                                const formData = new FormData();

                                // Update the formData object
                                if(irsaliye) {
                                    formData.append(
                                        "irsaliye",
                                        irsaliye,
                                        irsaliye.name
                                    );
                                }
                                if(siparisMektubu) {
                                    formData.append(
                                        "siparis_mektubu",
                                        siparisMektubu,
                                        siparisMektubu.name
                                    );
                                }

                                if(diger) {
                                    formData.append(
                                        "diger",
                                        diger,
                                        diger.name
                                    );
                                }

                                if(servisFormu) {
                                    formData.append(
                                        "servis_formu",
                                        servisFormu,
                                        servisFormu.name
                                    );
                                }

                                formData.append(
                                    "teklif_no",
                                    teklif_no
                                );
                                // Details of the uploaded file
                                //console.log(selectedFile);

                                // Request made to the backend api
                                // Send formData object
                                const secildi = Boolean(irsaliye || siparisMektubu || diger || servisFormu);
                                try {
                                    await api.post(
                                        `/teklifler/${encodeURIComponent(props.teklifNo)}/dosyalar`,
                                        formData
                                    );
                                    toast.success("Dosyalar yüklendi");
                                    if (secildi) {
                                        setYesil(true);
                                        if (typeof props.onSaved === "function") props.onSaved();
                                    }
                                } catch (e) {
                                    console.error(e);
                                    toast.error("Dosya yükleme başarısız");
                                    return;
                                }

                                setOpen(false);
                            }  }
                        color="primary"
                    >
                        Dosyaları Yükle
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog

                open={deleteFileState}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    {"Silme Onayı"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {props.teklifNo} no'lu teklife ait {selectedFileColumn} dosyasını istiyor musunuz?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>{deleteFile(selectedFileColumn,selectedFile)}}>
                        Evet
                    </Button>
                    <Button onClick={handleDeleteDialogClose} autoFocus>
                        Hayır
                    </Button>
                </DialogActions>
            </Dialog>

            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover

            />
        </div>
    )
}

